import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";

import { ButtonGroup } from "@mui/material";
import { Form } from "react-bootstrap";

import {
  getGeneralInformationCreateData,
  getGeneralInformationEditData,
  getGeneralInformationUpdateData,
  setDataGeneralInformation,
} from "./constantsGeneralInformation";

import { updateSelectsDependingDepartment } from "../../../../redux/accountManagementReducer/actionsAccountManagement";

import eye_off from "../../../../resourсes/eye-off.svg";
import eye from "../../../../resourсes/eye.svg";

import { customStyles, customErrorStyles } from "../accountManagementConfig";

import styles from "./generalInformation.module.css";

const GeneralInformation = ({ getData, isClickRoles, handleCloseClick, onSave, initialData, type }) => {
  const dispatch = useDispatch();

  const [isChecked, setIsChecked] = useState(initialData.note || "gims");
  const [fields, setFields] = useState([]);
  const [dataForm, setDataForm] = useState({});
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showRegisterPassword, setShowRegisterPassword] = useState(false);
  const [isDisabled, setIsDisabled] = useState("");
  const [isHandleSaveClick, setIsHandleSaveClick] = useState(false);
  const [saveEvent, setSaveEvent] = useState(undefined);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleRegisterPasswordVisibility = () => {
    setShowRegisterPassword(!showRegisterPassword);
  };

  const sections = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.gimsSections;
  });

  const departments = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.departmentAll;
  });

  const allGimsUserPositions = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.allGimsUserPositions;
  });

  const { userPositionOptins, sectionOptions } = useSelector((state) => state.accountManagementReducer);

  const handleButtonClick = (e, value) => {
    e.preventDefault();
    setIsChecked(value);
  };

  // todo: объединить 2 нижние функции
  async function setParamsForOptions() {
    await setDataGeneralInformation(sections, "section");
    await setDataGeneralInformation(departments, "department");
    await setDataGeneralInformation(allGimsUserPositions, "userPosition");

    if (type === "create") {
      setFields(Object.values(getGeneralInformationCreateData()));
    }
    if (type === "edit") {
      setFields(Object.values(getGeneralInformationEditData()));
    }
    if (type === "update") {
      setFields(Object.values(getGeneralInformationUpdateData()));
    }
  }

  async function setParams(userPositionOptins, sectionOptions) {
    await setDataGeneralInformation(sectionOptions, "section");
    await setDataGeneralInformation(userPositionOptins, "userPosition");

    if (type === "create") {
      setFields(Object.values(getGeneralInformationCreateData()));
    }
    if (type === "edit") {
      setFields(Object.values(getGeneralInformationEditData()));
    }
    if (type === "update") {
      setFields(Object.values(getGeneralInformationUpdateData()));
    }
  }

  const handleChangeSelectSearch = async (event, typeData) => {
    if (!event) return;

    if (typeData === "selectSearch") {
      const newDataForm = { ...dataForm };
      newDataForm[event.key] = event.value;
      setDataForm(newDataForm);

      if (!event.value) return;

      event.key === "department" && dispatch(updateSelectsDependingDepartment(event.value));
    } else {
      const newDataForm = { ...dataForm };
      newDataForm[event.currentTarget.id] = event.currentTarget.value;
      setDataForm(newDataForm);
    }
  };

  const checkIsGims = (field) => {
    if (dataForm.department === 7 || isChecked === "concerned") {
      return field?.key === "section";
    } else {
      return false;
    }
  };

  const editErrors = (buttonType) => {
    if (buttonType !== "save") return false;

    const newErrors = {};
    fields.forEach((field) => {
      if (field.required && !dataForm[field.key]) {
        newErrors[field.key] = `Заполните ${field.label}`;
      } else if (field.key === "password" && dataForm[field.key].length < 10) {
        newErrors[field.key] = `Пароль должен содержать 10 и более  символов`;
      } else if (field.key === "phone" && !/^[0-9+\s,;()-]*$/.test(dataForm[field.key])) {
        newErrors[field.key] = "Введены недопустимые символы";
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      setErrors({});
    }
  };

  const handleSaveClick = async (event) => {
    editErrors("save");
    setIsHandleSaveClick(true);
    setSaveEvent(event);
  };

  useEffect(() => {
    const countErrors = (errors) => {
      const errorKeys = Object.keys(errors);
      return errorKeys.length;
    };

    if (type === "update" && isHandleSaveClick && countErrors(errors) === 0) {
      setIsHandleSaveClick(false);
      onSave(dataForm, saveEvent);
    }
  }, [errors]);

  const setValueForSelectSearch = (field) => {
    return field.options.find((item) => Number(item.value) === Number(dataForm[field.key]));
  };

  useEffect(() => {
    if (isClickRoles) {
      editErrors("save");
    }
  }, [isClickRoles]);

  useEffect(() => {
    if (isChecked === "concerned" || dataForm.department === 7) {
      setDataForm({ ...dataForm, section: null });
    }
    if (isChecked === "concerned") {
      setFields([
        ...fields.map((item) => (item.key === "userPosition" ? { ...item, required: false } : item)),
      ]);
    } else {
      setFields([
        ...fields.map((item) => (item.key === "userPosition" ? { ...item, required: true } : item)),
      ]);
    }
  }, [isChecked, dataForm.department]);

  useEffect(() => {
    setParamsForOptions().then();
  }, [sections, departments, allGimsUserPositions]);

  useEffect(() => {
    setParams(userPositionOptins, sectionOptions).then();
  }, [userPositionOptins, sectionOptions]);

  useEffect(() => {
    if (type === "edit") {
      editErrors("save");
    }

    if (isClickRoles) {
      editErrors("save");
    }

    getData({ ...dataForm, note: isChecked }, errors);
  }, [dataForm]);

  useEffect(() => {
    getData({ ...dataForm, note: isChecked }, errors);
  }, [errors]);

  useEffect(() => {
    if (initialData.note === "gims") {
      setIsDisabled("concerned");
    } else {
      setIsDisabled("gims");
    }

    if (type === "update") {
      setDataForm({ ...initialData, password: "" });
    } else {
      setDataForm(initialData);
    }

    if (type === "edit") {
      dispatch(updateSelectsDependingDepartment(initialData.department));
    }
  }, []);

  return (
    <>
      <Form className={styles["container"]}>
        <div className={styles["box-buttons"]}>
          <ButtonGroup className={styles["buttons"]}>
            <button
              disabled={(type === "edit" || type === "update") && isDisabled === "gims"}
              className={isChecked === "gims" ? styles["button-selected"] : styles["button-not-selected"]}
              onClick={(e) => handleButtonClick(e, "gims")}>
              ГИМС
            </button>
            <button
              disabled={(type === "edit" || type === "update") && isDisabled === "concerned"}
              className={
                isChecked === "concerned" ? styles["button-selected"] : styles["button-not-selected"]
              }
              onClick={(e) => handleButtonClick(e, "concerned")}>
              Заинтересованный орган
            </button>
          </ButtonGroup>
        </div>
        {fields.map((field) => {
          if (field.type === "selectSearch") {
            if (checkIsGims(field)) return "";
            return (
              <Form.Group
                key={field.key}
                className={styles[`box-${field.key}`]}>
                <label className={styles["label"]}>{field.label}</label>
                {field.required && <span className={styles["red-dot"]}>*</span>}
                <Select
                  noOptionsMessage={() => "Нет данных"}
                  value={setValueForSelectSearch(field)}
                  classNamePrefix="custom-select"
                  styles={!!errors[field.key] ? customErrorStyles : customStyles}
                  onChange={(selectedOption) => {
                    const newValue = selectedOption?.value === null ? null : selectedOption.value;
                    handleChangeSelectSearch({ key: field.key, value: newValue }, field.type);
                  }}
                  placeholder="Выберите"
                  id={field.key}
                  isSearchable={field.isSearchable}
                  isDisabled={field.isDisabled}
                  name={field.key}
                  options={[{ value: null, label: `${field.label}` }, ...field.options]}
                />
                {!!errors[field.key] && (
                  <Form.Label className={styles["error"]}>{errors[field.key]}</Form.Label>
                )}
              </Form.Group>
            );
          } else if (field.type === "password") {
            return (
              <Form.Group
                key={field.key}
                className={styles[`box-${field.key}`]}>
                <label className={styles["label"]}>
                  {field.label}
                  {field.required && <span className={styles["red-dot"]}>*</span>}
                </label>
                <div className={styles["input-group"]}>
                  <input
                    autoComplete={field.key === "password" ? "new-password" : "off"}
                    className={styles["form-input"]}
                    id={field.key}
                    disabled={field.disabled}
                    placeholder="Введите"
                    type={
                      field.key === "password"
                        ? showPassword
                          ? "text"
                          : "password"
                        : showRegisterPassword
                        ? "text"
                        : "password"
                    }
                    value={dataForm[field.key] || ""}
                    onChange={(e) => handleChangeSelectSearch(e)}
                  />
                  {(type === "create" || type === "update") && (
                    <div className={styles["input-group-img-block"]}>
                      <img
                        className={styles["input-group-img"]}
                        onClick={
                          field.key === "password"
                            ? togglePasswordVisibility
                            : toggleRegisterPasswordVisibility
                        }
                        style={{ cursor: "pointer" }}
                        src={
                          field.key === "password"
                            ? showPassword
                              ? eye_off
                              : eye
                            : showRegisterPassword
                            ? eye_off
                            : eye
                        }
                        alt="eye"
                      />
                    </div>
                  )}
                </div>
                {!!errors[field.key] && (
                  <Form.Label className={styles["error"]}>{errors[field.key]}</Form.Label>
                )}
              </Form.Group>
            );
          } else {
            if (checkIsGims(field)) return "";
            return (
              <Form.Group
                key={field.key}
                className={styles[`box-${field.key}`]}>
                <label className={styles["label"]}>
                  {field.label}
                  {field.required && <span className={styles["red-dot"]}>*</span>}
                </label>
                <input
                  autoComplete="off"
                  className={styles["form-input"]}
                  id={field.key}
                  disabled={field.disabled}
                  placeholder="Введите"
                  type={field.type}
                  value={dataForm[field.key] || ""}
                  onChange={(e) => handleChangeSelectSearch(e)}
                />
                {!!errors[field.key] && (
                  <Form.Label className={styles["error"]}>{errors[field.key]}</Form.Label>
                )}
              </Form.Group>
            );
          }
        })}
      </Form>
      <Form.Group className={styles["actions-buttons-block"]}>
        {type === "update" && (
          <button
            className={styles["save-btn"]}
            onClick={(event) => handleSaveClick(event)}>
            Сохранить
          </button>
        )}
        <button
          className={styles["close-btn"]}
          onClick={handleCloseClick}>
          Закрыть
        </button>
      </Form.Group>
    </>
  );
};

export default GeneralInformation;
